import { Navigate, Route, Routes } from "react-router-dom";
import { useIsMobile } from "@/v2/hooks/useIsMobile";
import V2AdminLayout from "./layouts/AdminLayout";
import V2AttorneyLayout from "./layouts/AttorneyLayout";
import SettingsLayout from "./layouts/SettingsLayout";
import AdminBilling from "./pages/admin/Billing";
// Admin pages
import AdminDashboard from "./pages/admin/Dashboard";
import AdminMatters from "./pages/admin/Matters";
import AdminSupport from "./pages/admin/Support";
import AdminTimekeeper from "./pages/admin/Timekeeper";
import AdminUpdates from "./pages/admin/Updates";
import Calendar from "./pages/CalendarPage";
import Docs from "./pages/Docs";
// Pages
import Entries from "./pages/Entries";
import FAQ from "./pages/FAQ";
import Support from "./pages/Support";
import Abbreviations from "./pages/settings/Abbreviations";
import MyMatters from "./pages/settings/MyMatters";
import Narratives from "./pages/settings/Narratives";
import Preferences from "./pages/settings/Preferences";
import RestrictedWords from "./pages/settings/RestrictedWords";
// Settings pages
import SettingsIndex from "./pages/settings/SettingsIndex";
import Tracking from "./pages/settings/Tracking";
import Updates from "./pages/Updates";

interface V2RoutesProps {
	isAdmin: boolean;
	canViewBilling: boolean;
	canManageMatters: boolean;
	isMatterOnlyAdmin: boolean;
}

export function V2Routes({
	isAdmin,
	canViewBilling,
	canManageMatters,
	isMatterOnlyAdmin,
}: V2RoutesProps) {
	const isMobile = useIsMobile();

	return (
		<Routes>
			<Route
				path="/"
				element={
					<Navigate to={isAdmin && !isMobile ? "/admin" : "/entries"} replace />
				}
			/>

			{/* Admin routes — blocked on mobile */}
			<Route
				path="/admin"
				element={
					isAdmin && !isMobile ? (
						<V2AdminLayout />
					) : (
						<Navigate to="/entries" replace />
					)
				}
			>
				<Route
					index
					element={
						<Navigate
							to={isMatterOnlyAdmin ? "/admin/matters" : "/admin/dashboard"}
							replace
						/>
					}
				/>
				<Route path="dashboard" element={<AdminDashboard />} />
				<Route
					path="billing"
					element={
						canViewBilling ? (
							<AdminBilling />
						) : (
							<Navigate to="/admin/dashboard" replace />
						)
					}
				/>
				<Route
					path="matters"
					element={
						canManageMatters ? (
							<AdminMatters />
						) : (
							<Navigate to="/admin/dashboard" replace />
						)
					}
				/>
				<Route path="timekeeper" element={<AdminTimekeeper />} />
				<Route path="support" element={<AdminSupport />} />
				<Route path="updates" element={<AdminUpdates />} />
			</Route>

			{/* Settings routes (own layout) */}
			<Route path="/settings" element={<SettingsLayout />}>
				<Route index element={<SettingsIndex />} />
				<Route path="preferences" element={<Preferences />} />
				<Route path="tracking" element={<Tracking />} />
				<Route path="narratives" element={<Narratives />} />
				<Route path="restricted-words" element={<RestrictedWords />} />
				<Route path="abbreviations" element={<Abbreviations />} />
				<Route path="my-matters" element={<MyMatters />} />
			</Route>

			{/* Attorney routes */}
			<Route element={<V2AttorneyLayout />}>
				<Route path="/entries" element={<Entries />} />
				<Route path="/calendar" element={<Calendar />} />
				<Route path="/support" element={<Support />} />
				<Route path="/faq" element={<FAQ />} />
				<Route path="/updates" element={<Updates />} />
				<Route path="/docs" element={<Docs />} />
			</Route>
		</Routes>
	);
}
